import { MessageFilterTypes } from 'components/SMS/TwoWay/Model';
import { Message, Meta, ProspectConversation, ProspectConversationDetail } from 'model/ProspectMessage';

export interface ProspectMessageState {
    status: ProspectMessageStatus;
    loading: boolean;
    error: string | Record<string, string[]> | null;
    saveMessageError: string | Record<string, string[]> | null;
    prospectConversations: Array<ProspectConversation>;
    metaProspectConversations: Meta | null;
    prospectConversationDetail: ProspectConversationDetail | null;
    filter: MessageFilterTypes | null;
    query: string | null;
    newMessage?: Message | undefined;
}

export enum ProspectMessageStatus {
    Initial,
    Cleared,
    Setting,
    FetchingConversations,
    FetchingConversationsSuccess,
    FetchingConversationsError,
    FetchingConversationDetail,
    FetchingConversationDetailSuccess,
    FetchingConversationDetailError,
    Saving,
    SaveSuccess,
    Error,
    UpdateSuccess,
    SavingEmptyMessage,
    SaveEmptyMessageSuccess,
    SaveEmptyMessageError
}
